import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LokaliseService } from './lokalise.service';
import { LOKALISE_ENV_ENABLED, LOKALISE_USER_ENABLED } from './provider';

@Injectable()
export class LokaliseTranslateService extends TranslateService {
  private enabledEnvToken = inject(LOKALISE_ENV_ENABLED);
  private enabledUserToken = inject(LOKALISE_USER_ENABLED);
  private lokaliseService = inject(LokaliseService);

  public instant(
    key: string | Array<string>,
    interpolateParams?: object
  ): string | any {
    const translation = super.instant(key, interpolateParams);

    if (!this.enabledEnvToken || !this.enabledUserToken) {
      // Return translation, Lokalise script is not enabled
      return translation;
    }

    if (typeof key === 'string') {
      this.lokaliseService.translationAdded.next();
      return `{.${key.replaceAll('.', '::')}.}`;
    }

    return translation;
  }
}
